import { render } from "./HiVaultImageControl.vue?vue&type=template&id=261061f0&scoped=true"
import script from "./HiVaultImageControl.vue?vue&type=script&lang=js"
export * from "./HiVaultImageControl.vue?vue&type=script&lang=js"

import "./HiVaultImageControl.vue?vue&type=style&index=0&id=261061f0&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-261061f0"]])

export default __exports__